import {
  PRODUCTOPTION,
  DESIGN,
  UPDATE_OPTION,
  SELECT_PRINT_OPTION,
} from "../actions";
import calculatePreviewScale from "../services/utils/calculatePreviewScale";

const initialState = {
  isFetching: false,
  error: null,
  product_option: null,
  options: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case DESIGN.REQUEST:
      return Object.assign({}, state, {
        isFetching: true,
      });

    case DESIGN.SUCCESS:
      const data = action.response;

      const product_option = {
        //product_id: data.id,
        error: false,
        ...data.product_option,
      };

      product_option.preview_scale = calculatePreviewScale(product_option);
      if (isNaN(product_option.preview_scale)) {
        product_option.error =
          "Invalid Product Configuration. Check Product Dimensions";
      }

      return Object.assign({}, state, {
        isFetching: false,
        entity: product_option,
        options: [product_option],
      });

    case DESIGN.FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        error: "Failed Loading Product",
      });

    /**
     * After we load the Design, we make a request for the Product Options that are tied to the Design's Product Variant.
     */
    case PRODUCTOPTION.SUCCESS:
      let newOptionsState = Object.assign({}, state);
      let toAdd = [];
      action.response.forEach((newOption) => {
        let found = newOptionsState.options.find(
          (option) => newOption.id === option.id,
        );
        if (!found) {
          toAdd.push(newOption);
        }
      });

      newOptionsState.options = [...newOptionsState.options, ...toAdd];
      return newOptionsState;

    case UPDATE_OPTION:
    case SELECT_PRINT_OPTION:
      let found = state.options.find(
        (option) => action.payload.option.id === option.id,
      );
      return {
        ...state,
        entity: found,
      };

    default:
      return state;
  }
}
